<div class="h-100" [ngStyle]="outerCss">
  <div class="support-chat-widget-container">
    <div #messageContainer class="messages-container d-flex flex-col gap-3" (scroll)="onScroll($event)">
      @if (noActiveChat) {
      <div [innerHTML]="noActiveChatTemplateString | safeHtml"></div>
      } @else if (isNewSupportChat) {
        @if (welcomeMessageText) {
          <div class="message body-1 received mr-auto">
            {{ welcomeMessageText }}
          </div>
        } @else {
          <div class="text-center">Send a message to start a new conversation</div>
        }
      } @else { @for (message of messagesList; track message.id) {
      <!-- Date Separator -->
      @if (shouldShowDateSeparator($index)) {
      <div class="date-separator">
        <span>{{ getDateSeparatorLabel(message.createdAt) }}</span>
      </div>
      }
      <div class="message body-1" [ngClass]="message.isAdmin ? 'received mr-auto' : 'sent ml-auto'">
        {{ message.content }}
        <div
          class="text-caption mt-1 d-flex align-items-center labelText gap-2"
          [ngClass]="message.isAdmin ? 'opacity-4' : 'justify-content-end opacity-8'"
        >
          <div>{{ message.createdAt | date : 'HH:mm' }}</div>
          @if (!message.isAdmin) {
          <mat-icon [svgIcon]="'double-tick'"></mat-icon>
          }
        </div>
      </div>
      } }
    </div>
    <div class="text-input-container p-2">
      @if((!isWorkflow || !attri?.['previewClosedChatMessage']) && (isWorkflow || activeChatStatus !==
      threadStatusEnum.CLOSED)) {
      <form [formGroup]="messageForm" class="d-flex align-items-center justify-between gap-2">
        @if (activeDevice === devicetypes.DESKTOP) {
        <textarea
          #messageTextarea
          id="message-input"
          class="w-100 message-textarea"
          [formControlName]="'message'"
          placeholder="Type a message..."
          [attr.autofocus]="true"
          (input)="autoResizeTextarea(messageTextarea)"
          (keydown.enter)="onEnterKey($event)"
        >
        </textarea>
        } @else {
        <finxone-input
          class="w-100"
          [placeholder]="'Type a message...'"
          [formControlName]="'message'"
          [value]="messageForm.get('message')?.value || ''"
          [autofocus]="true"
          [id]="'message-input'"
        ></finxone-input>
        }
        <button type="button" [ngStyle]="buttonStyles" (click)="sendMessage()" [disabled]="noActiveChat">
          <mat-icon [svgIcon]="btnIcon"></mat-icon>
        </button>
      </form>
      }@else {
      <div class="close-chat-message" [innerHTML]="closedChatTemplateString | safeHtml"></div>
      }
    </div>
  </div>
</div>
